<template lang="pug">
.v-field-range.field-range(:class="{'field-range--opened': mobOpened}")
	button.field-range__btn-toggle(v-if="isSm"
			type="button"
			:class="{'field-check-list__btn-toggle--opened': mobOpened}"
			@click="toggle")
	label.field-range__label.field-label(v-if="field.label"
			:class="{'field-range__label--active': localValue && (typeof localValue.min === 'number' || localValue.max === 'number')}")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
		v-svg-icon.field-text__arrow-right(v-if="isSm" icon="chevron-right-sm")
	.field-range__overlay(v-if="isSm" @click="close")
	.field-range__main
		//-button.modal-window__close(v-if="isSm" type="button" aria-label="Закрыть" @click="close")
		//-	.modal-window__close-text Закрыть
		//-	v-svg-icon.modal-window__close-icon(icon="close")
		.field-check-list__mob-header(v-if="isSm")
			button.field-check-list__close(type="button" @click="close")
				v-svg-icon.field-check-list__close-icon(icon="close")
			.field-check-list__mob-label {{field.label}}
			button.field-check-list__mob-reset(v-if="localValue" type="button" @click="reset") Сбросить
		template(v-if="field.switchers")
			v-switchers
		.field-range__cells.flc
			.field-range__prefix(v-if="field.prefixMin") {{field.prefixMin}}
			.field-range__cell
				template(v-if="field.maskMin")
					input.field-input(v-imask="field.maskMin"
							:value="localValue.min"
							:placeholder="field.placeholder || field.placeholderMin"
							@accept="onAcceptMin"
							@complete="onCompleteMin")
				template(v-else)
					v-field.field-range__input(:field="{type: 'text', inputmode: (field.inputmode ? field.inputmode : 'decimal'), disabled: field.disabled, precision: field.precision, placeholder: field.placeholderMin}"
							v-model="localValue.min"
							@update:model-value="handleInput"
							@keyup.native.enter="emitInput")
				.field-range__postfix(v-if="field.postfixMin") {{field.postfixMin}}
			.field-range__spacer -
			.field-range__prefix(v-if="field.prefixMax") {{field.prefixMax}}
			.field-range__cell
				template(v-if="field.maskMax")
					input.field-input(v-imask="field.maskMax"
							:value="localValue.max"
							:placeholder="field.placeholder || field.placeholderMax"
							@accept="onAcceptMax"
							@complete="onCompleteMax")
				template(v-else)
					v-field.field-range__input(:field="{type: 'text', inputmode: (field.inputmode ? field.inputmode : 'decimal'), disabled: field.disabled, precision: field.precision, placeholder: field.placeholderMax}"
							v-model="localValue.max"
							@update:model-value="handleInput"
							@keyup.native.enter="emitInput")
			.field-range__postfix(v-if="field.postfixMax") {{field.postfixMax}}
	.field-range__desktop-reset-wrap(v-if="!isSm && localValue && (localValue.min || localValue.max)")
		button.field-check-list__spoiler-btn.field-check-list__spoiler-btn--reset(type="button" @click="reset") Сбросить
</template>

<script>
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		isMobMixin
	],

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Object,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],
	
	data() {
		return {
			localValue: null,
			debounceTimeout: null,
			savedValueMin: null,
			savedValueMax: null,
			unmaskedValueMin: null,
			unmaskedValueMax: null,
			fullUnmaskedValueLengthMin: 0,
			fullUnmaskedValueLengthMax: 0,
			mobOpened: false
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		reset() {
			this.localValue.min = '';
			this.localValue.max = '';
			this.emitInput();
			this.close();
		},

		toggle() {
			if (this.isSm) {
				if (this.mobOpened) {
					this.close();
				} else {
					this.open();
				}
			}
		},

		open() {
			if (this.isSm) {
				this.mobOpened = true;
			}
		},

		close() {
			if (this.isSm) {
				this.mobOpened = false;
			}
		},

		onAcceptMin(e) {
			this.localValue.min = e.detail.unmaskedValue;
		},

		onAcceptMax(e) {
			this.localValue.max = e.detail.unmaskedValue;
		},

		onCompleteMin(e) {
			this.localValue.min = e.detail.value;
			if (this.localValue.min) {
				this.handleInput();
			}
		},

		onCompleteMax(e) {
			this.localValue.max = e.detail.value;
			if (this.localValue.max) {
				this.handleInput();
			}
		},

		updateLocalValue() {
			this.localValue = this.modelValue || {min: this.field.min || 0, max: this.field.max || 0};
		},

		handleInput() {
			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(this.emitInput, 1000);
		},

		emitInput() {
			clearTimeout(this.debounceTimeout);
			if (this.field) {
				if (!this.field.maskMin && typeof this.field.min == 'number' && this.field.min !== -Infinity && this.localValue.min && this.localValue.min < this.field.min) {
					this.localValue.min = this.field.min;
				}
				if (!this.field.maskMax && typeof this.field.max == 'number' && this.field.max !== Infinity && this.localValue.max && this.localValue.max > this.field.max) {
					this.localValue.max = this.field.max;
				}
			}
			this.$emit('update:model-value', this.localValue);
		}
	}
};
</script>
